const paramsDictionary = {
  personalDifficulties: 'personalDifficultyIds',
  provinces: 'provinceIds',
  genders: 'genderIds'
}
export default paramsDictionary
